import React from "react";
import { useNavigate } from "react-router-dom";
import CreateCampaignImg from "../../../assets/images/create-campaign.svg";
import "./CreateFirstCampaign.css";

const CreateFirstCampaign = () => {
  const navigate = useNavigate();

  return (
    <div class="createCampaignMain">
      <div className="createFirstCampaignHeader">
        <h2>Your Dashboard</h2>
        <p className="p_createFirstHeader">Check out the insight of your campaign</p>
      </div>

    <div id="createFirstCampaign">
      <div className="createFirstCampaignImg">
        <img
          className="createFirstCampaign-img"
          src={CreateCampaignImg}
          alt="create-first-campaign-img"
        />
      </div>
      <div class="createFirstCampaign-info">
        <h2 className="createFirstCampaign-info-heading">
          Create your first campaign
        </h2>
        <p className="createFirstCampaign-info-subHeading">
          Please create your first campaign to get more reach for your business
          and view the insights of your campaign in here
        </p>
        <button
          className="createFirstCampaign-button"
          onClick={() => navigate("/create-campaign")}
        >
          Create a campaign
        </button>
      </div>
    </div>
    </div>
  );
};

export default CreateFirstCampaign;
